import { render, staticRenderFns } from "./SqlConfig.vue?vue&type=template&id=68aa8130&scoped=true&"
import script from "./SqlConfig.vue?vue&type=script&lang=js&"
export * from "./SqlConfig.vue?vue&type=script&lang=js&"
import style0 from "./SqlConfig.vue?vue&type=style&index=0&id=68aa8130&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa8130",
  null
  
)

export default component.exports